module.exports = __webpack_public_path__ + "static/media/jane_street_fr.373405d3.png";